import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

const initialState = {
  partnerInfo: {},
  listReferralPartner: [],
  isGetReferralPartners: false,
  isUpdateReferralPartner: false,
  isRemoveReferralPartner: false,
  total: 0,
};

export const referralPartnersSlice = createSlice({
  name: "referral-partners",
  initialState,
  reducers: {
    getReferralPartnersRequest: (state) => {
      state.isGetReferralPartners = true;
    },
    getReferralPartnersSuccess: (state, { payload }) => {
      state.isGetReferralPartners = false;
      state.listReferralPartner = payload.data;
      state.total = payload.total;
    },
    getReferralPartnersFailure: (state) => {
      state.isGetReferralPartners = false;
    },
    getReferralPartnerByIdRequest: (state) => {
      state.isGetReferralPartnerById = true;
    },
    getReferralPartnerByIdSuccess: (state, { payload }) => {
      state.isGetReferralPartnerById = false;
      state.partnerInfo = payload;
    },
    getReferralPartnerByIdFailure: (state) => {
      state.isGetReferralPartnerById = false;
    },
    updateReferralPartnerRequest: (state) => {
      state.isUpdateReferralPartner = true;
    },
    updateReferralPartnerSuccess: (state, { payload }) => {
      state.isUpdateReferralPartner = false;
      state.listReferralPartner = payload;
      message.success("Update partner successfully!");
    },
    updateReferralPartnerFailure: (state) => {
      state.isUpdateReferralPartner = false;
    },
    removeReferralPartnerRequest: (state) => {
      state.isRemoveReferralPartner = true;
    },
    removeReferralPartnerSuccess: (state, { payload }) => {
      state.isRemoveReferralPartner = false;
      state.listReferralPartner = payload;
      state.total -= 1;
      message.success("Remove partner successfully!");
    },
    removeReferralPartnerFailure: (state) => {
      state.isRemoveReferralPartner = false;
    },
    getStatusEmailSentW9FormRequest: (state) => {
      state.isGetStatusEmailSentW9Form = true;
    },
    getStatusEmailSentW9FormSuccess: (state, { payload }) => {
      state.isGetStatusEmailSentW9Form = false;
      state.isSentEmailW9Form = payload;
    },
    getStatusEmailSentW9FormFailure: (state) => {
      state.isGetStatusEmailSentW9Form = false;
    },
    sendEmailW9FormRequest: (state) => {
      state.isSendingEmailW9Form = true;
    },
    sendEmailW9FormSuccess: (state, { payload }) => {
      state.isSendingEmailW9Form = false;
      state.isSentEmailW9Form = true;
      message.success("Send email successfully!");
    },
    sendEmailW9FormFailure: (state) => {
      state.isSendingEmailW9Form = false;
    },
    checkProvidedW9FormRequest: (state) => {
      state.isCheckingProvidedW9Form = true;
    },
    checkProvidedW9FormSuccess: (state, { payload }) => {
      state.isCheckingProvidedW9Form = false;
      state.isProvidedW9Form = payload;
      message.success("Check provided successfully!");
    },
    checkProvidedW9FormFailure: (state) => {
      state.isCheckingProvidedW9Form = false;
    },
  },
});

export const {
  getReferralPartnersRequest,
  getReferralPartnersSuccess,
  getReferralPartnersFailure,
  getReferralPartnerByIdRequest,
  getReferralPartnerByIdSuccess,
  getReferralPartnerByIdFailure,
  updateReferralPartnerRequest,
  updateReferralPartnerSuccess,
  updateReferralPartnerFailure,
  removeReferralPartnerRequest,
  removeReferralPartnerSuccess,
  removeReferralPartnerFailure,
  getStatusEmailSentW9FormRequest,
  getStatusEmailSentW9FormSuccess,
  getStatusEmailSentW9FormFailure,
  sendEmailW9FormRequest,
  sendEmailW9FormSuccess,
  sendEmailW9FormFailure,
  checkProvidedW9FormRequest,
  checkProvidedW9FormSuccess,
  checkProvidedW9FormFailure,
} = referralPartnersSlice.actions;

export default referralPartnersSlice.reducer;
